import { levelTypeToTheoryType } from "./Education.functions";
import type { Level, LevelType } from "./Education.types";

export type LevelModalLoadingShell = {
  selectedLevelType: LevelType | null;
};

/** Opens the level modal immediately while ids and content are still loading. */
export function createLevelModalLoadingShell(
  level: Level,
): LevelModalLoadingShell {
  return {
    selectedLevelType: levelTypeToTheoryType(level.LevelType),
  };
}
